import { render, staticRenderFns } from "./detalhesUsuario.vue?vue&type=template&id=442bbdfc&scoped=true&"
import script from "./detalhesUsuario.vue?vue&type=script&lang=js&"
export * from "./detalhesUsuario.vue?vue&type=script&lang=js&"
import style0 from "./detalhesUsuario.vue?vue&type=style&index=0&id=442bbdfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442bbdfc",
  null
  
)

export default component.exports